import {
  Component,
  ViewChild,
  effect,
  input,
} from '@angular/core';

import {
  ApexNonAxisChartSeries,
  ApexPlotOptions,
  ApexChart,
  ChartComponent,
  NgApexchartsModule,
  ApexFill,
  ApexStroke,
  ApexGrid,
  ApexLegend,
} from 'ng-apexcharts';
import { CspNonceService } from '../../service/csp-nonce.service';
export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  labels: string[];
  plotOptions: ApexPlotOptions;
  fill: ApexFill;
  stroke: ApexStroke;
  grid: ApexGrid;
  legend: ApexLegend;
};
@Component({
    selector: 'app-radial-bar',
    imports: [NgApexchartsModule],
    templateUrl: './radial-bar.component.html',
    styleUrl: './radial-bar.component.scss'
})
export class RadialBarComponent {
  @ViewChild('radialChart') chart!: ChartComponent;
  public chartOptions: any = {
    series: [],
    chart: { type: 'radialBar' },
    plotOptions: {},
    labels: [],
    fill: {},
    stroke: {},
    grid: {},
    legend: { show: false },
    dataLabels: { enabled: false },
    tooltip: { enabled: true },
    responsive: []
  };
  dataLabel = input.required<string>();
  dataSeries = input.required<number>();
  maxSize = input<number>(120);

  constructor(private readonly cspNonceService: CspNonceService
) {
    const nonce = this.cspNonceService.getNonce() ?? undefined;
    effect(() => {
      const series = this.dataSeries();
      const label = this.dataLabel();
      
      if (series === undefined || series === null || !label) {
        return;
      }

      const newOptions: any = {
        series: [series],
        chart: {
          foreColor: '#50BF75',
          type: 'radialBar',
          nonce: nonce
        },
        plotOptions: {
          radialBar: {
            track: {
              background: '#A0A0A0',
            },
            offsetY: 2,
            hollow: {
              size: '65%',
            },
            dataLabels: {
              value: {
                offsetY: -19,
                color: '#50BF75',
                fontWeight: 'bold',
                fontSize: '18px',
              },
              name: {
                offsetY: 18,
                fontWeight: 400,
                color: '#fff',
                fontSize: '14px',
                fontFamily: 'Roboto',
              },
            },
          },
        },
        grid: {
          padding: {
            top: -15,
            left: -15,
            right: -15,
            bottom: -15,
          },
        },
        labels: [label],
        fill: {
          colors: ['#50BF75'],
        },
        stroke: {
          lineCap: 'round',
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true
        }
      };
      
      // Always ensure legend exists before ApexCharts receives the config
      if (!newOptions.legend) {
        newOptions.legend = { show: false };
      }
      
      this.chartOptions = newOptions;
    });
  }
}
